import React from 'react'
import ReactDOM from 'react-dom/client'
import { EventType } from '@azure/msal-browser'
import type { AuthenticationResult, EventMessage } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { msalInstance } from './auth/msalConfig'
import { configurarSoporte, installErrorCapture } from './soporte'
import { SOPORTE_INTERNO } from './lib/soporte'
// Fuentes self-hosted (sin CDN externo ni ajustes de CSP). Inter = UI;
// IBM Plex Mono = datos (RFC, importes, folios, UUID, OTP).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import './index.css'

// Antes que nada: así el reporte de problemas también ve errores del arranque.
installErrorCapture()
// Canal interno por defecto (Bearer de Entra); el portal pasa el suyo como `config`.
configurarSoporte(SOPORTE_INTERNO)

async function bootstrap() {
  // MSAL browser v3+ exige inicialización explícita antes de usar la instancia.
  // Sin esto el provider lanza `uninitialized_public_client_application`.
  await msalInstance.initialize()

  // Selecciona la cuenta activa tras un login exitoso o si ya había una en cache.
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const result = event.payload as AuthenticationResult
      if (result.account) msalInstance.setActiveAccount(result.account)
    }
  })
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(accounts[0])
  }

  // Procesa la respuesta del redirect PKCE antes de montar la app —
  // evita flashes de la pantalla de login justo después del callback.
  await msalInstance.handleRedirectPromise()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  )
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('[main] Error inicializando MSAL:', err)
  const root = document.getElementById('root')
  if (root) {
    root.innerHTML =
      '<div style="padding:2rem;font-family:system-ui;color:#b91c1c">' +
      '<h1>Error de inicialización</h1>' +
      '<p>No se pudo inicializar la autenticación. Revisa las variables de entorno y la consola.</p>' +
      '</div>'
  }
})
